import { DeactivateStaffInput } from '../../lib/types/models/staff/admin-staff-input'
import { Staff } from '../../lib/types/models/staff/staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deactivateStaff = (id: number, input: DeactivateStaffInput) => {
  return restApiClient
    .url(constructApiUrl(API.staffs.deactivate.url, { id }))
    .post<Staff, DeactivateStaffInput>(input)
}
